import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const Games = () => {
  const navigate = useNavigate();
  const { username } = useParams();

  const games = [
    {
      title: "🌬️ Breathing Exercise",
      desc: "Relax and calm your mind with guided breathing.",
      route: `/games/breathinggame`,
      available: true,
    },
    {
      title: "🧘 Zen Memory",
      desc: "A calming memory match using soothing emojis.",
      route: `/games/zenmemory`,
      available: true,
    },
    {
      title: "🧘‍♂️ Meditation",
      desc: "Find peace through guided meditation practices.",
      route: `/games/meditation`,
      available: true,
    },
    {
      title: "� Bubble Zen",
      desc: "Pop bubbles mindfully in this relaxing zen game.",
      route: `/games/bubblezen`,
      available: true,
    },
  ];

  const handlePlay = (game) => {
    if (!game.available) {
      alert("This game is coming soon!");
      return;
    }
    // Include the username from params (if present) so the app's
    // PrivateRoute (/:username/...) works as expected.
    if (username) navigate(`/${username}${game.route}`);
    else navigate(game.route);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 p-6">
      <h1 className="text-4xl font-bold text-gray-800 mb-10">
        Wellness Games
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {games.map((game, index) => (
          <div
            key={index}
            className="bg-white shadow-lg rounded-2xl p-6 w-72 hover:shadow-xl transition duration-300 flex flex-col justify-between"
          >
            <div>
              <h2 className="text-xl font-semibold text-gray-800 mb-3">
                {game.title}
              </h2>
              <p className="text-gray-600 mb-6">{game.desc}</p>
            </div>
            <button
              onClick={() => handlePlay(game)}
              className={`px-4 py-2 rounded-lg text-white font-medium ${
                game.available
                  ? "bg-blue-500 hover:bg-blue-600"
                  : "bg-gray-400 cursor-not-allowed"
              } transition-all`}
            >
              {game.available ? "Play Now" : "Coming Soon"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Games;
